import React from 'react';
import type { UiError } from './errors';

interface Props {
  error: UiError | null;
}

/**
 * Renders a service error. For the activation lock (409 with `reasons`) the server message already
 * joins the reasons, so only the headline plus the list is shown instead of repeating them.
 */
const ErrorBox: React.FC<Props> = ({ error }) => {
  if (!error) return null;
  const hasReasons = Boolean(error.reasons && error.reasons.length > 0);
  return (
    <div className="ev-error">
      {hasReasons ? 'This preset cannot be activated yet:' : error.message}
      {hasReasons && (
        <ul>
          {(error.reasons || []).map((reason) => <li key={reason}>{reason}</li>)}
        </ul>
      )}
    </div>
  );
};

export default ErrorBox;
